import type { ChosenSuperconnector } from '@ah/people/shared';

export function readCachedSuperconnector(): ChosenSuperconnector | null {
  try {
    const raw = localStorage.getItem('me.chosenSuperconnector');
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ChosenSuperconnector>;
    if (!parsed?.firstName || !parsed?.pictureUrl || !parsed?.gender) return null;
    return {
      firstName: parsed.firstName,
      lastName: parsed.lastName ?? '',
      pictureUrl: parsed.pictureUrl,
      gender: parsed.gender,
    };
  } catch {
    return null;
  }
}
